import { IconButtonVariantTheme } from '@sternum/ui';

export const sizes: IconButtonVariantTheme['sizes'] = {
  large: '34px',
  big: '28px',
  medium: '24px',
  small: '16px',
};
